// extracted by mini-css-extract-plugin
export default {"container":"AlertsList_container__rYC2j"};